import { getGameDataIndex } from '@op/components/TableCommonHook/hooks/useCompareKeyMetricsColumns';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import {
  getOverviewCompetitorTable,
  getOverviewCompetitorTimeline,
} from '@op/services';
import { sortMapAuxiliaryFunc } from '@op/utils';
import { useEffect, useRef, useState } from 'react';
import { dealwithMentionsSentimentTable } from '../utils';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import { isEqual } from 'lodash-es';
export function useCompareKeyMetricsTable({
  filter,
  dealwithToTable = dealwithMentionsSentimentTable,
  gameData,
  defaultSortKey,
}: any) {
  const [tableRecords, setTableRecords] = useState<Array<any>>([]);
  const { Competitor_Rank_Hide } = useGetSingePageSourceRule({
    keys: ['Competitor_Rank_Hide'],
  });
  const { loading, wrapperRequest } = useCancelRequestHook();
  const prevFilterRef = useRef<any>(null);

  function requestTable() {
    if (Competitor_Rank_Hide) return;
    if (!filter?.edition_unified_id) return;
    wrapperRequest(cancelFunc => {
      return getOverviewCompetitorTable(filter, cancelFunc).then(
        (data: any) => {
          const table = dealwithToTable(data, filter);
          const sortMap = getGameDataIndex(gameData);
          table.sort(
            sortMapAuxiliaryFunc(sortMap, item => item.edition_unified_id),
          );
          // 默认表数据按首例数值排序
          if (defaultSortKey) {
            const firstObj = table.shift();
            table.sort(
              (a, b) => (b?.[defaultSortKey] || 0) - (a?.[defaultSortKey] || 0),
            );
            table.unshift(firstObj);
          }
          setTableRecords(table);
        },
      );
    });
  }

  useEffect(() => {
    if (Competitor_Rank_Hide) {
      prevFilterRef.current = null;
      return;
    }
    if (isEqual(prevFilterRef.current, filter)) return;
    prevFilterRef.current = filter;
    requestTable();
  }, [filter, Competitor_Rank_Hide]);

  return { tableRecords, loading };
}

export function useCompareKeyMetricsChart({ filter, dealWithToChart }: any) {
  const [chartRecord, setChartRecord] = useState<{
    xAxisData?: any;
    yAxisData?: any;
    tableData?: any;
  }>({});
  const [error, setError] = useState(false);
  const { loading, wrapperRequest } = useCancelRequestHook();
  const prevFilterRef = useRef<any>(null);
  function requestChart() {
    if (!filter.edition_unified_id) return;
    setError(false);
    wrapperRequest(cancelFunc =>
      getOverviewCompetitorTimeline(filter, cancelFunc)
        .then((data: any) => {
          const chart = dealWithToChart?.(data, filter) || data;
          setChartRecord(chart);
        })
        .catch(() => {
          setError(true);
        }),
    );
  }

  useEffect(() => {
    if (isEqual(prevFilterRef.current, filter)) return;
    prevFilterRef.current = filter;
    requestChart();
  }, [filter]);

  return { data: chartRecord, loading, error, refetch: requestChart };
}
